<template>
  <div id="chart-line-use-month-box">
    <div class="chart-title">
      <img class="charts-icon" :src="require('@/assets/images/largescreen/charts-icon.png')" alt="">
      <dv-decoration-1/>
      <span>{{ areaName === 'china' ? '全国' : areaName }}使用量逐月变动情况</span>
    </div>
    <div id="chart-line-use-month"/>
  </div>
</template>

<script>
import resize from '@/utils/resize'

export default {
  mixins: [resize],
  name: "bodyLeftBottom",
  data() {
    return {
      chart: null,
      mapJsonData: {
        used: [],
        usedDate: [],
        deviceCount: [], // 参与设备数量
      }
    }
  },
  props: {
    areaName: {
      type: String,
      default: 'china'
    },
    monthUseNumber: {
      type: Array,
      default() {
        return []
      }
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
    
    // 监听屏幕方向变化
    window.addEventListener('orientationchange', this.handleOrientationChange)
  },
  watch: {
    monthUseNumber: {
      handler(val) {
        this.mapJsonData = {
          used: [],
          usedDate: [],
          deviceCount: [],
        }
        for (var i = 0; i < val.length; i++) {
          this.mapJsonData.used.push(val[i].used)
          this.mapJsonData.usedDate.push(val[i].usedDate)
          this.mapJsonData.deviceCount.push(val[i].deviceCount || 0)
        }
        // ✅ 优化：只更新数据，不重新初始化图表
        this.updateChartData()
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
    
    // 移除监听器
    window.removeEventListener('orientationchange', this.handleOrientationChange)
  },
  methods: {
    handleOrientationChange() {
      // 屏幕方向变化后，延迟重新渲染图表
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 300)
    },
    initChart() {
      // ✅ 优化：避免重复初始化
      if (!this.chart) {
        this.chart = this.$echarts.init(document.getElementById('chart-line-use-month'))
      }
      this.setOptions()
    },
    // ✅ 新增：仅更新图表数据，不重新初始化
    updateChartData() {
      if (!this.chart) {
        // ✅ 确保DOM元素存在后再初始化
        this.$nextTick(() => {
          this.initChart()
        })
        return
      }
      
      // 只更新series数据和x轴数据
      this.chart.setOption({
        xAxis: [{
          data: this.mapJsonData.usedDate
        }],
        yAxis: [
          {},
          {
            max: this.getDeviceAxisMax() // ✅ 同步更新右轴最大值
          }
        ],
        series: [
          {
            data: this.mapJsonData.used
          },
          {
            data: this.mapJsonData.deviceCount
          }
        ]
      })
    },
    // ✅ 右轴最大值取设备数峰值的2倍，使折线视觉上位于图表中部
    getDeviceAxisMax() {
      const maxVal = Math.max(0, ...this.mapJsonData.deviceCount)
      return maxVal > 0 ? maxVal * 2 : null
    },
    setOptions() {
      // ✅ 检测是否为移动端和1080p大屏
      const isMobile = window.innerWidth <= 768;
      const isLargeScreen = window.innerWidth >= 1920 && window.innerHeight >= 1080;
      
      // ✅ 根据屏幕尺寸动态调整字体大小
      const fontSize = isLargeScreen ? 14 : (isMobile ? 9 : 10);
      const nameFontSize = isLargeScreen ? 16 : (isMobile ? 12 : 14);
      
      this.chart.setOption({
        color: ['#28CFA7', '#FFD166'],
        legend: {
          show: true,
          top: 0,
          left: 'center', // ✅ 居中，避免与两侧Y轴名称重叠
          textStyle: {
            color: '#fff',
            fontSize: fontSize
          }
        },
        xAxis: [{
          type: 'category',
          data: this.mapJsonData.usedDate,
          boundaryGap: true,
          axisTick: {
            show: false
          },
          axisLabel: {
            rotate: 30,
            textStyle: {
              fontSize: fontSize // ✅ 动态字体大小
            }
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
            }
          },
          //网格样式
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(125, 155, 243, .2)',
              width: .5,
              type: 'solid'
            }
          },
        }],
        dataZoom: [//滑动条
          {
            type: 'inside',
            realTime: true,
            roam: true,
            startValue: 0, // 从头开始。
            endValue: 7  // 一次性展示6个。
          }
        ],
        yAxis: [{
          type: 'value',
          name: '单位/人次',
          minInterval: 1,
          nameTextStyle: {
            fontSize: nameFontSize, // ✅ 动态字体大小
            color: "#fff",
            padding: [0, -20, -10, 0],
          },
          axisTick: {
            show: false//隐藏y坐标轴刻度
          },
          axisLabel: {//y轴字体样式
            rotate: 60,
            textStyle: {
              fontSize: fontSize // ✅ 动态字体大小
            }
          },
          axisLine: {
            show: true, //隐藏y坐标轴
            lineStyle: {
              color: '#fff',
            }
          },
          //网格样式
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(125, 155, 243, .2)',
              width: .5,
              type: 'solid'
            }
          },
        }, {
          // ✅ 右侧Y轴：参与设备数（折线专用）
          type: 'value',
          name: '单位/台',
          max: this.getDeviceAxisMax(), // ✅ 峰值×2，折线居中显示
          minInterval: 1,
          nameTextStyle: {
            fontSize: nameFontSize,
            color: '#FFD166',
            padding: [0, -20, -10, 0],
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              fontSize: fontSize,
              color: '#FFD166'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#FFD166',
            }
          },
          // 右轴不显示网格线，避免与左轴网格重叠
          splitLine: {
            show: false
          },
        }],
        grid: {
          left: 0,
          right: 10,
          bottom: 0,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          },
          padding: [5, 10],
        },
        series: [
          {
            name: '使用数量',
            type: 'bar',
            stack: '使用数量',
            smooth: false,  //这个是把线变成曲线
            // areaStyle: {}, //填充区域样式
            data: this.mapJsonData.used,
            barWidth: '50%',
            // ✅ 在柱状图上显示数字
            label: {
              show: true,
              position: 'top',
              fontSize: 10,
              color: '#fff',
              formatter: '{c}'
            }
          },
          {
            name: '参与设备数',
            type: 'line',
            yAxisIndex: 1, // ✅ 使用右侧Y轴
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: this.mapJsonData.deviceCount,
            lineStyle: {
              width: 2
            },
            // ✅ 在折线上显示数字
            label: {
              show: true,
              position: 'top',
              fontSize: 10,
              color: '#FFD166',
              formatter: '{c}'
            }
          }
        ]
      })
    },
  }
}
</script>

<style lang="scss" scoped>
#chart-line-use-month-box {
  background: rgba(125, 155, 243, .2);
  height: calc(33.3%);
  //margin-bottom: 10px;

  .chart-title {
    display: flex;
    align-items: center; // ✅ 垂直居中对齐
    color: #fff;
    font-weight: bolder;
    padding: 5px 10px;
    background: rgba(125, 155, 243, .2);
    position: relative;

    .charts-icon{
      width: 20px;
      height: 25px;
      position: absolute;
      left: 15px;
      top: 0;
    }
    .dv-decoration-1 {
      width: 50px;
      height: 18px;
    }
  }

  #chart-line-use-month {
    height: calc(100% - 30px);
  }
}

// 平板端和手机横屏适配
@media screen and (min-width: 769px) {
  #chart-line-use-month-box {
    .chart-title {
      span {
        font-size: 12px !important;
      }
    }
  }
}

// 手机横屏特殊处理
@media screen and (orientation: landscape) and (max-height: 768px) {
  #chart-line-use-month-box {
    height: calc((100% - 30px) / 3) !important; // ✅ 三等分，减去边距和padding
    margin-bottom: 0 !important; // 最后一个不需要底部边距
  }
}

// 手机竖屏适配
@media screen and (max-width: 768px) and (orientation: portrait) {
  #chart-line-use-month-box {
    height: 300px !important;
    margin-bottom: 10px;
    
    .chart-title {
      padding: 8px 10px !important;
      
      span {
        font-size: 13px !important;
        margin-left: 35px !important;
      }
      
      .charts-icon {
        width: 16px !important;
        height: 20px !important;
        left: 10px !important;
      }
      
      .dv-decoration-1 {
        width: 40px !important;
        height: 15px !important;
      }
    }
    
    #chart-line-use-month {
      height: calc(100% - 40px) !important;
    }
  }
}

// ✅ 1080p 屏幕专属优化
@media screen and (min-width: 1920px) and (max-width: 2560px) and (min-height: 1080px) and (max-height: 1440px) {
  #chart-line-use-month-box {
    .chart-title {
      span {
        font-size: 18px !important; // ✅ 增大标题字体
      }
      
      .charts-icon {
        width: 24px !important;
        height: 30px !important;
      }
      
      .dv-decoration-1 {
        width: 70px !important;
        height: 24px !important;
      }
    }
  }
}
</style>
